export default {"src":"/_next/static/media/star.2b44ff6a.svg","height":20,"width":24,"blurWidth":0,"blurHeight":0};